@if (isAlertOpen) {
    <div class="oben">
        @if (alertMessage.length > 0) {
            <ngb-alert type="info" [dismissible]="true" (close)="closeAlert()">
                {{ alertMessage | translate }}<br />
            </ngb-alert>
        }
    </div>
}
<app-slider>
    @if (env.fanshopLocales.includes(locale)) {
        <div appSlide backgroundImage="/assets/images/slider/fanshop.jpg">
            <div class="container">
                <h1 style="margin-bottom: 15px">
                    {{ "banner.fanshop-title" | translate }}
                </h1>
                <poe-button
                    theme="image"
                    (tapClick)="navigateToFanshop()"
                    >{{ "banner.fanshop-cta" | translate }}</poe-button
                >
            </div>
        </div>
    }

    @if (!isLoggedIn) {
        <div
            appSlide
            backgroundImage="https://www.poettinger.at/img/mediapool/assets/175398/2000/POETTINGER_NOVACAT_V9200_Steyr_68_SAT.jpg"
        >
            <div class="container">
                <h1 style="margin-bottom: 15px">{{ "ejue" | translate }}</h1>
                <poe-button theme="image" appLoginButton>{{
                    "login-now" | translate
                }}</poe-button>
            </div>
        </div>
    }

    @if (!user?.wantsNewsletter) {
        <div
            appSlide
            backgroundImage="https://www.poettinger.at/img/mediapool/assets/55187/2000/SERVO_T_6000_Fendt_Einsatzaufnahmen_210810__DSC6978-1.jpg"
        >
            <div class="container">
                <h1>{{ "AdvertNewsletter" | translate }}</h1>
                <poe-button theme="image" (tapClick)="onClickNewsletter()">{{
                    "hintForNewsletter" | translate
                }}</poe-button>
            </div>
        </div>
    }
    <div
        appSlide
        backgroundImage="/assets/images/slider/customer-configurator.webp"
    >
        <div class="container">
            <h1>Maschinenkonfigurator</h1>
            <poe-button
                theme="image"
                [routerLink]="['/', env.p.machinesearch]"
                >{{ "start-now" | translate }}</poe-button
            >
        </div>
    </div>
</app-slider>

<div class="container">
    <article class="d-block d-lg-none">
        <strong>{{ "AllFunctions" | translate }}</strong>
        <p class="pt-4">
            {{
                isLoggedIn
                    ? ("WelcomeText" | translate)
                    : ("RegText" | translate)
            }}
        </p>
        @if (!user?.wantsNewsletter) {
            <p>
                {{ "AdvertNewsletter" | translate }} <br />
                {{ "CallForActionNewsletter" | translate }}
                <span
                    (click)="onClickNewsletter()"
                    (keydown)="onClickNewsletter()"
                    class="link"
                >
                    {{ "hintForNewsletter" | translate }}</span
                >
            </p>
        }
    </article>
    <div class="row pr-2 pl-2">
        <app-tile
            class="col-sm-6"
            [class]="
                env.fanshopLocales.includes(locale) ? 'col-md-4' : 'col-md-3'
            "
            style="padding: 5px"
            imageSrc="/assets/images/Icon_Maschinensuche.svg"
            label="{{ 'goToProducts' | translate }}"
            [destination]="`/${env.p.machinesearch}`"
        ></app-tile>
        <app-tile
            class="col-sm-6"
            [class]="
                env.fanshopLocales.includes(locale) ? 'col-md-4' : 'col-md-3'
            "
            style="padding: 5px"
            imageSrc="/assets/images/Icon_MyMaschine.svg"
            label="{{ 'myMachines' | translate }}"
            destination="/myMachines"
            requiresLogin="false"
        ></app-tile>
        <app-tile
            class="col-sm-6"
            [class]="
                env.fanshopLocales.includes(locale) ? 'col-md-4' : 'col-md-3'
            "
            style="padding: 5px"
            imageSrc="/assets/images/Piktogramm_Endkundenkonfigurator.svg"
            label="{{ 'configurator' | translate }}"
            [destination]="`/${env.p.configurator}`"
            requiresLogin="false"
        ></app-tile>
        <app-tile
            class="col-sm-6"
            [class]="
                env.fanshopLocales.includes(locale) ? 'col-md-4' : 'col-md-3'
            "
            style="padding: 5px"
            imageSrc="/assets/images/machine-advisor.svg"
            label="{{ 'machineAdvisor' | translate }}"
            destination="/machine-advisor"
        ></app-tile>
        @if (env.fanshopLocales.includes(locale)) {
            <app-tile
                (tapClick)="trackFanshopNavigation()"
                class="col-sm-6 col-md-4"
                style="padding: 5px"
                imageSrc="/assets/images/Piktogramm_Fanshop.svg"
                label="{{ 'fanshop' | translate }}"
                destination="//fanshop.mypoettinger.com"
            ></app-tile>
        }
    </div>
</div>
